import { useState } from "react";
import { Badge, Button, ListGroup } from "react-bootstrap";
import AnkietaFormModal from "./AnkietaFormModal";
import DeleteSurveyInstanceModal from "./DeleteSurveyInstanceModal";

export default function PacjentSurveyListItem({ surveyInstance, onDeleted }) {
  let label = "Czeka na wypełnienie";
  let color = "primary";

  const [modalShown, setModalShown] = useState(false);
  const [deleteModalShown, setDeleteModalShown] = useState(false);

  switch (surveyInstance.surveyStatus) {
    case 0:
      label = "Czeka na wypełnienie";
      color = "secondary";
      break;
    case 1:
      label = "W trakcie wypełniania";
      color = "primary";
      break;
    case 2:
      label = "Wypełniona";
      color = "success";
      break;
    case 3:
      label = "Wymaga uwagi!";
      color = "danger";
      break;
  }

  const surveyStatus = {
    label: label,
    color: color,
  };

  return (
    <ListGroup.Item
      as="li"
      className="d-flex justify-content-between align-items-center"
    >
      <div className="ms-2 me-auto">
        <div className="fw-bold">
          <Badge className="m-2" bg={surveyStatus.color} pill>
            {surveyStatus.label}
          </Badge>
          {surveyInstance.patient.name} {surveyInstance.patient.surname}{" "}
          {surveyInstance.patient.pesel}
        </div>
      </div>

      {surveyInstance.surveyStatus > 1 && (
        <Button
          onClick={() => setModalShown(true)}
          className="p-2 ms-auto"
          variant="link"
          size="sm"
        >
          Wyświetl odpowiedzi
        </Button>
      )}
      <Button
        onClick={() => setDeleteModalShown(true)}
        className="p-2"
        variant="link"
        size="sm"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
          <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"/>
          <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z"/>
        </svg>
      </Button>
      <AnkietaFormModal
        surveyId={surveyInstance.instanceId}
        show={modalShown}
        onHide={() => setModalShown(false)}
      />
      <DeleteSurveyInstanceModal
        instanceId={surveyInstance.instanceId}
        patientName={`${surveyInstance.patient.name} ${surveyInstance.patient.surname}`}
        show={deleteModalShown}
        onHide={() => setDeleteModalShown(false)}
        onDeleted={onDeleted}
      />
    </ListGroup.Item>
  );
}
